import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { MainStoreState } from 'modules/main/store/MainStoreState';
import { StaffStoreState } from 'modules/staff/store/StaffStoreState';
import { AmpContext } from 'utils/AmpContext';

type Props = {
  store: Store<MainStoreState | StaffStoreState>;
  requestIsAmp: boolean;
  children?: ReactNode;
};

export function RenderingWrapper({ store, requestIsAmp, children }: Props) {
  return (
    <Provider store={store}>
      <AmpContext.Provider value={requestIsAmp}>{children}</AmpContext.Provider>
    </Provider>
  );
}
